import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { IAction } from '../action/IAction';
import { Attribute } from '../attribute/Attribute';

@Component({
    selector: 'wbm-config-action',
    templateUrl: './config-action.component.html',
})
export class ConfigActionComponent implements OnInit {
    private _action: IAction;
    private formGroup: FormGroup;

    @Input()
    set action(action: IAction) {
        this._action = action;
        this.formGroup = this.getActionInfoControls();
    }

    get action() {
        return this._action;
    }

    @Output() submitAction: EventEmitter<Object> = new EventEmitter();
    @Output() cancelAction: EventEmitter<any> = new EventEmitter();

    constructor(private _fb: FormBuilder) { }

    ngOnInit() {
    }

    private getActionInfoControls(): FormGroup {
        let controls = [] ;
        for (let key in this._action.info.value) {
            if (this._action.info.value.hasOwnProperty(key)) {
                let actionInfo = this._action.info.value[key];
                if (actionInfo.isOctetString && actionInfo.structure['type'].pattern) {
                    let pattern: string = actionInfo.structure['type'].pattern;
                    controls[actionInfo.name] = this._fb.control(actionInfo.value , Validators.pattern(pattern));
                } else if (actionInfo.isInteger && actionInfo.structure['type'].values) {
                    let acceptedValues: Array<any> = actionInfo.structure['type'].values;
                    let constraintsLogic = Attribute.getJSONLogicFromIntegerContraints(acceptedValues);
                    controls[actionInfo.name] = this._fb.control(actionInfo.value , this.createIntegerValidator(constraintsLogic));
                } else {
                    controls[actionInfo.name] = this._fb.control(actionInfo.value);
                }
            }
        }
        return this._fb.group(controls);
    }

    private createIntegerValidator(constraintsLogic: Object) {
        return (c: FormControl) => {
            return jsonLogic.apply(constraintsLogic, { 'attrValue': c.value }) ? null : {
                validateInteger: {
                    valid: false
                }
            };
        };
    }


    onSubmit() {
        let value = this.formGroup.value;

        //Do action on backend
        this.submitAction.emit(value);
    }

    onCancel() {
        this.cancelAction.emit();
    }
}
